import { useRouter } from 'next/router';
import { SFErrorBoundary } from '@/components/ErrorBoundary';
import { TopNavStyles } from '@/components/TopNav/TopNav.styles';
import useUser from '@/hooks/useUser';
import selectUserType from '@/store/user/selectors/selectUserType';
import useTranslation from '@/hooks/useTranslation';
import { SHIPPING_SAVINGS_PRICE } from '@/constants/env';

const NavLogin = (): JSX.Element | null => {
  const { t } = useTranslation();
  const router = useRouter();
  const user = useUser();
  const { isLoggedIn } = selectUserType(user);

  if (isLoggedIn) return null;

  const handleLoginClick = () => {
    sessionStorage.setItem('preLoginRoute', router.asPath);
    router.push('/login');
  };

  const loginDiscountPrice = SHIPPING_SAVINGS_PRICE || 7;

  return (
    <SFErrorBoundary targetComponent={'LOGIN'} fallbackComponent={undefined}>
      <button style={TopNavStyles.navLoginButton} onClick={handleLoginClick}>
        {t('login.discount', { shippingSavingsPrice: loginDiscountPrice })}
      </button>
    </SFErrorBoundary>
  );
};

export default NavLogin;
